import moment from "moment";

export function formatDateTime(iso) {
    return iso ? moment(iso).format("DD/MM/YYYY HH:mm") : "";
}

export function formatTime(iso) {
    return iso ? moment(iso).format("HH:mm") : "";
}

export function formatDate(iso) {
    return iso ? moment(iso).format("DD/MM/YYYY") : "";
}

export function formatRelative(iso) {
    return iso ? moment(iso).fromNow() : "";
}

export function formatMoney(cents, currencyCode = "EUR") {
    if (cents === null || cents === undefined) {
        return "";
    }

    return new Intl.NumberFormat("fr-FR", {style: "currency", currency: currencyCode || "EUR"}).format(cents / 100);
}

export function factLabel(label) {
    const words = String(label).replace(/_/g, " ");

    return words.charAt(0).toUpperCase() + words.slice(1);
}
